export const ApiDef_ColorGroup = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map